import { useQuery } from "@tanstack/react-query";
import { getUsageSummary } from "@/services/admin-api";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { AdminSectionCard } from "@/components/admin/AdminSectionCard";

export default function AIUsage() {
  const { data, isLoading } = useQuery({
    queryKey: ["ai-usage"],
    queryFn: () => getUsageSummary(),
  });

  if (isLoading) {
    return <div className="p-8">Loading...</div>;
  }

  const summary = data?.data ?? null;

  if (!summary) {
    return <div className="p-8">No usage data available</div>;
  }

  const successRate =
    summary.totalCalls > 0 ? ((summary.successCalls / summary.totalCalls) * 100).toFixed(1) : "0.0";

  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="AI Usage Analytics"
        description="Monitor AI service usage and costs"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-sm font-medium text-gray-500">Total Calls</div>
          <div className="text-3xl font-bold mt-2">{summary.totalCalls.toLocaleString()}</div>
          <div className="text-xs text-gray-500 mt-1">
            {summary.errorCalls.toLocaleString()} errors
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-sm font-medium text-gray-500">Success Rate</div>
          <div className="text-3xl font-bold mt-2">{successRate}%</div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-sm font-medium text-gray-500">Total Tokens</div>
          <div className="text-3xl font-bold mt-2">
            {(summary.totalInputTokens + summary.totalOutputTokens).toLocaleString()}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {summary.totalCachedTokens.toLocaleString()} cached
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-sm font-medium text-gray-500">Total Cost</div>
          <div className="text-3xl font-bold mt-2">${summary.totalCost.toFixed(4)}</div>
        </div>
      </div>

      <AdminSectionCard title="Token Breakdown">
        <div className="grid grid-cols-3 gap-4 text-sm">
          <div>
            <div className="text-gray-500">Input Tokens</div>
            <div className="font-medium">{summary.totalInputTokens.toLocaleString()}</div>
          </div>
          <div>
            <div className="text-gray-500">Output Tokens</div>
            <div className="font-medium">{summary.totalOutputTokens.toLocaleString()}</div>
          </div>
          <div>
            <div className="text-gray-500">Cached Tokens</div>
            <div className="font-medium">{summary.totalCachedTokens.toLocaleString()}</div>
          </div>
        </div>
      </AdminSectionCard>
    </div>
  );
}
